import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayMore',
})
export class ArrayMorePipe implements PipeTransform {
  transform(
    array: string[],
    inline: number = 3
  ): { display: string; more: number | null } {
    return {
      display: array?.slice(0, inline)?.join(', '),
      more: array?.length > inline ? array?.length - inline : null,
    };
  }
}
